module.exports = ".fa-stack-1x {\n  color: white; }\n\n.icon-facebook {\n  color: #3b5998; }\n\n.icon-twitter {\n  color: #00aced; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-main/components/page-layout/page-layout.component.scss
// module id = ./src/app/modules/common-main/components/page-layout/page-layout.component.scss
// module chunks = main